module.exports = __webpack_public_path__ + "992b48f8cbce2cb388e7f8d47afc2c9d.MP3";